(function ($) {

  const $bigWrapper = $('.view-id-highlighted_series.view-display-id-all');
  const $tagWrapper = $bigWrapper.find('.bef-links');
  const $titleWrapper = $bigWrapper.find('.view-header');
  const $tags = $tagWrapper.find('ul');
  const $secondItem = $tags.children().eq(1);
  const $toScroll = $bigWrapper.find('.bef-links');

  const $buttonWrappers = $('<div>').addClass('tagWrapper');
  const $prevButton = $('<div>').addClass('tag-button nav-button--prev is-disabled');
  const $nextButton = $('<div>').addClass('tag-button nav-button--next');

  if ($secondItem.length == 0 || $tagWrapper.length === 0){
    return;
  }

  $titleWrapper.wrap( "<div class='titleTagWrapper'></div>" );
  $buttonWrappers.insertAfter($titleWrapper);
  $prevButton.appendTo($buttonWrappers);
  $nextButton.appendTo($buttonWrappers);

  const scrollDuration = 250;
  const scrollStep = $secondItem.width() + Number($secondItem.css('margin-left').replace('px', ''));

  function moveSlider(dir) {
    console.log($toScroll)
    $toScroll.animate({
      scrollLeft: $toScroll.scrollLeft() + scrollStep * dir
    }, scrollDuration);
  };

  function setNavButtonVisibility() {
    const scrollLeft = $toScroll.scrollLeft();
    const maxScroll = $toScroll[0].scrollWidth - $toScroll[0].clientWidth;

    if (scrollLeft >= maxScroll) {
      $nextButton.addClass('is-disabled');
    }
    if (scrollLeft <= 0) {
      $prevButton.addClass('is-disabled');
    }
    if (scrollLeft > 0 && scrollLeft < maxScroll){
      $prevButton.removeClass('is-disabled');
      $nextButton.removeClass('is-disabled');
    }
  };

  $toScroll.on('scroll', setNavButtonVisibility);

  // ---------------
  // Event handlers
  // ---------------

  $prevButton.on('click', () => moveSlider(-1));
  $nextButton.on('click', () => moveSlider(1));

})(jQuery);